import {
  fetchBotTemplate,
  installBotTemplate,
  resetInstallation,
  resolveConflict,
} from 'apps/templates/actions/templateInstallation'
import * as atypes from 'apps/templates/constants/ReduxActionTypes'

const initialState = {
  generalElementsConflicts: {
    wm: true,
    dr: true,
    mm: true,
    gtext: true,
    igdr: true,
    sm: true,
    ib: true,
    igib: true,
    igmm: true,
  },
  signature: null,
  isInstalling: false,
  isInstallingComplete: false,
  installationId: null,
  generalElements: {
    wm: null,
    mm: null,
    dr: null,
    gtext: null,
    igdr: null,
    sm: null,
    ib: null,
    igib: null,
    igmm: null,
  },
  settings: {},
}

export default function templateInstallationReducer(state = initialState, action) {
  switch (action.type) {
    case resolveConflict.type: {
      const { payload } = action
      const generalElementsConflicts = { ...state.generalElementsConflicts, ...payload }
      return { ...state, generalElementsConflicts }
    }
    case fetchBotTemplate.fulfilled.type: {
      const { template_data, user_info } = action.payload
      return { ...state, template_data, user_info }
    }
    case fetchBotTemplate.rejected.type: {
      return { ...state, error: action.payload }
    }
    case installBotTemplate.pending.type: {
      const {
        meta: {
          arg: { signature },
        },
      } = action
      return { ...state, isInstalling: true, signature }
    }
    case installBotTemplate.fulfilled.type: {
      const { payload } = action
      return { ...state, signature: payload.async }
    }
    case installBotTemplate.rejected.type: {
      return { ...state, isInstalling: false }
    }
    case atypes.TEMPLATES_INSTALLATION_STATUS_UPDATE: {
      const { done, result } = action.data
      if (done) {
        return {
          ...state,
          isInstalling: false,
          isInstallingComplete: true,
          installationId: result.template_installation_id,
        }
      }
      return state
    }
    case resetInstallation.type: {
      return initialState
    }
  }

  return state
}
